<template id="pagination-template">
  <ul class="pagination" data-cy="pagination">
    <li>
      <button class="buttons" type="button" @click="onClickPreviousPage" :disabled="isInFirstPage">
        <font-awesome-icon :icon="['fas', 'angle-left']" size="lg" />
        <span class="ml-2">Vorige</span>
      </button>
    </li>

    <li v-show="showStartDots">
      <button class="page" type="button" @click="onClickFirstPage" :disabled="isInFirstPage">1</button>
    </li>

    <li v-show="showStartDots">
      <span class="dots">...</span>
    </li>

    <li v-for="page in pages" :key="page.name">
      <button class="page" type="button" @click="onClickPage(page.name)" :disabled="page.isDisabled" :class="{ active: isPageActive(page.name) }">
        {{ page.name }}
      </button>
    </li>

    <li v-show="showEndDots">
      <span class="dots">...</span>
    </li>

    <li v-show="showEndDots">
      <button class="page" type="button" @click="onClickLastPage" :disabled="isInLastPage">
        {{ totalPages }}
      </button>
    </li>

    <li>
      <button class="buttons" type="button" @click="onClickNextPage" :disabled="isInLastPage">
        <span class="mr-2">Volgende</span>
        <font-awesome-icon :icon="['fas', 'angle-right']" size="lg" />
      </button>
    </li>
  </ul>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  template: '#pagination-template',
  components: {
    FontAwesomeIcon
  },
  props: {
    maxVisibleButtons: {
      type: Number,
      default: 5
    },
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      start: 1,
      offset: 0,
      maxButtons: 5
    };
  },
  computed: {
    pages() {
      this.init();

      const range = [];
      const calc = Math.min(this.start + this.maxButtons - 1, this.totalPages);

      const end = this.currentPage + this.offset;

      if (end >= this.totalPages) {
        this.setStartPage(this.start - (end - this.totalPages));
      }

      for (let i = this.start; i <= calc; i++) {
        range.push({ name: i, isDisabled: i === this.currentPage });
      }
      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    showEndDots() {
      return (
        this.totalPages - (this.currentPage + this.offset) > 0 &&
        this.offset > 0
      );
    },
    showStartDots() {
      const end = this.currentPage - this.offset;
      return 1 - end < 0 && this.offset > 0;
    }
  },
  methods: {
    onClickFirstPage() {
      this.$emit('page-changed', 1);
    },
    onClickPreviousPage() {
      this.$emit('page-changed', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('page-changed', page);
    },
    onClickNextPage() {
      this.$emit('page-changed', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('page-changed', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
    init() {
      if (this.totalPages <= this.maxVisibleButtons) {
        this.maxButtons = this.totalPages;
        this.offset = 0;
      } else {
        this.maxButtons = 5;
        this.offset = (this.maxButtons - 1) / 2;
      }

      const start = this.currentPage - this.offset;
      this.start = start > 0 && this.offset > 0 ? start : 1;
    },
    setStartPage(page) {
      this.start = page;
    }
  }
};
</script>
